/* Cat Eye move on cursor */
const radius = 18; // max movement radius

document.addEventListener('mousemove', e => {
  document.querySelectorAll('.catSVG').forEach(svg => {
    const rect = svg.getBoundingClientRect();
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;

    svg.querySelectorAll('.leftEye, .rightEye').forEach(eye => {
      const centerX = parseFloat(eye.getAttribute('data-center-x'));
      const centerY = parseFloat(eye.getAttribute('data-center-y'));
      const dx = mouseX - centerX;
      const dy = mouseY - centerY;
      const angle = Math.atan2(dy, dx);
      const x = centerX + Math.cos(angle) * radius;
      const y = centerY + Math.sin(angle) * radius;
      eye.setAttribute('cx', x);
      eye.setAttribute('cy', y);
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname === "/") {
    document.querySelectorAll("#hdt-nav-ul a").forEach(function (link) {
      link.addEventListener("click", function (e) {
        const href = this.getAttribute("href");

        if (href && href.includes("/#")) {
          e.preventDefault(); // stop default jump

          // get the ID after #
          const targetId = href.split("#")[1];
          const targetEl = document.getElementById(targetId);

          if (targetEl) {
            targetEl.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        } else {
          // normal redirect
          window.location.href = href;
        }
      });
    });
  }
});